// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"0c9c1325","63":"dee66be2","119":"7425a347","234":"1686ed57","279":"6d862b49","289":"526e9fd1","373":"0a1aae77","452":"39bd7234","522":"c2074699","571":"42317e98","983":"a22d75e2"}[chunkId] + ".chunk.js";
};